import Component from "@glimmer/component";
import { action, computed } from "@ember/object";
import { service } from "@ember/service";
import CreateTopicButton from "discourse/components/create-topic-button";
import routeAction from "discourse/helpers/route-action";
import { NotificationLevels } from "discourse/lib/notification-levels";
import CirclesNotificationsButton from "./notifications-button";

export default class CirclesMemberActions extends Component {
  @service currentUser;
  @service currentCircle;

  @computed("hasDraft")
  get createTopicLabel() {
    return this.hasDraft ? "topic.open_draft" : "topic.create";
  }

  @computed("hasDraft")
  get createTopicClass() {
    let classNames = ["btn-default"];
    if (this.hasDraft) {
      classNames.push("open-draft");
    }
    return classNames.join(" ");
  }

  get canCreateTopic() {
    return this.currentCircle.userCanCreateTopic;
  }

  @computed("currentUser.has_topic_draft")
  get hasDraft() {
    return !!this.currentUser?.has_topic_draft;
  }

  @computed("args.model.is_circle_member")
  get isCategoryNotificationsButtonVisible() {
    return this.currentCircle.userIsMember;
  }

  @computed("args.model.category.notification_level")
  get categoryNotificationLevel() {
    if (
      this.currentUser?.indirectly_muted_category_ids?.includes(
        this.args.model.category.id
      )
    ) {
      return NotificationLevels.MUTED;
    } else {
      return this.args.model.category.notification_level;
    }
  }

  @action
  changeCategoryNotificationLevel(notificationLevel) {
    this.args.model.category.setNotification(notificationLevel);
  }

  <template>
    <div class="circles-nav-actions">
      <CreateTopicButton
        @label={{this.createTopicLabel}}
        @canCreateTopic={{this.canCreateTopic}}
        @action={{routeAction "clickCreateTopicButton"}}
        @disabled={{this.createTopicButtonDisabled}}
        @btnClass={{this.createTopicClass}}
      />

      {{#if this.isCategoryNotificationsButtonVisible}}
        <CirclesNotificationsButton
          @value={{this.categoryNotificationLevel}}
          @category={{@model.category}}
          @onChange={{this.changeCategoryNotificationLevel}}
        />
      {{/if}}
    </div>
  </template>
}
